import { z } from 'zod';
import { timestampSchema } from './common.schemas';

/**
 * Organization Management Schemas
 */

// Organization object
export const organizationSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
    plan: z.enum(['starter', 'growth', 'professional', 'enterprise']),
    status: z.enum(['active', 'suspended', 'cancelled']),
  })
  .merge(timestampSchema);

// Create organization
export const createOrganizationSchema = z.object({
  name: z.string().min(1).max(100),
  slug: z
    .string()
    .min(3)
    .max(50)
    .regex(/^[a-z0-9-]+$/, 'Slug must contain only lowercase letters, numbers, and hyphens'),
});

// Update organization
export const updateOrganizationSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  plan: z.enum(['starter', 'growth', 'professional', 'enterprise']).optional(),
  status: z.enum(['active', 'suspended', 'cancelled']).optional(),
});

// Organization settings
export const organizationSettingsSchema = z.object({
  aiTransparencyEnabled: z.boolean().default(false),
  proactiveBiasMonitoring: z.boolean().default(false),
  dataResidency: z.enum(['us', 'eu', 'asia']).default('us'),
  llmCostLimit: z.number().positive().optional(),
  autoEscalationEnabled: z.boolean().default(true),
  escalationThreshold: z.number().min(0).max(100).default(75),
});

// Export inferred types
export type Organization = z.infer<typeof organizationSchema>;
export type CreateOrganizationInput = z.infer<typeof createOrganizationSchema>;
export type UpdateOrganizationInput = z.infer<typeof updateOrganizationSchema>;
export type OrganizationSettings = z.infer<typeof organizationSettingsSchema>;
